import { NavItem } from '@ukam/shell/layouts/full/vertical/sidebar/nav-item/nav-item';

export const complianceNav: NavItem[] = [
  { navCap: 'Consentimento' },
  { displayName: 'Authorization Terms', iconName: 'solar:shield-check-linear', route: '/authorization-terms' },
  { displayName: 'Signatures', iconName: 'solar:pen-new-square-linear', route: '/signatures' },
];
